import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_GRATUITY_RULES_ABOVE_N_YEAR_UN_LIMITEDS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.EDIT_GRATUITY_RULES_ABOVE_N_YEAR_UN_LIMITED:
      return { ...state, [action.payload.Id]: action.payload };
    default:
      return state;
  }
};
